import { Box } from '@mui/material';
import ReportChartCard from '../report-chart-card-conversation';
import AssignmentsCard from '../assignments-chart-card';
import ConversationTableCard from '../conversation-table-card';

const AssignmentDetail = ({ conversation, isEvaluation, version, evaluationId }) => {
  // const series = [conversation.]

  return (
    <Box display="flex" flexDirection="column" gap={4} sx={{ marginTop: 7 }}>
      <ReportChartCard
        completed={conversation?.completed}
        inProgress={conversation?.inProgress}
        notStarted={conversation?.notStarted}
      />
      <AssignmentsCard
        conversation={conversation}
        isEvaluation={isEvaluation}
        version={version}
        evaluationId={evaluationId}
      />
      <ConversationTableCard conversation={conversation} />
    </Box>
  );
};

export { AssignmentDetail };
